import React from "react";
import { Eyebrow } from "../../components/site/kit";
import { Reveal } from "../../components/site/motion";
import { useHomeCopy } from "../../lib/siteContent";
import { RichCopy } from "../../components/site/RichCopy";
import { MODEL_STEPS, TrajectorySpine } from "./shared";

export const SwitchModel = () => {
  const c = useHomeCopy();
  return (
  <section data-testid="home-model" className="relative overflow-hidden border-y border-white/10 bg-[#161A15]">
    <div className="relative mx-auto max-w-[1360px] px-6 py-24 md:px-12 md:py-32 lg:px-16">
      <div className="grid gap-10 lg:grid-cols-12 lg:items-center lg:gap-16">
        <div className="lg:col-span-7">
          <Eyebrow dark>{c.modelEyebrow}</Eyebrow>
          <h2 className="font-display mt-6 text-4xl leading-[0.95] tracking-tight text-white md:text-5xl lg:text-6xl">
            <RichCopy text={c.modelHeading} />
          </h2>
          <p className="font-body mt-6 max-w-2xl text-xl font-normal leading-relaxed text-white/80">
            {c.modelIntro}
          </p>
        </div>
        <Reveal className="hidden lg:col-span-5 lg:block">
          <div className="relative overflow-hidden border border-white/10">
            <img
              src="/assets/editorial-model.jpg"
              alt=""
              aria-hidden
              loading="lazy"
              decoding="async"
              className="aspect-[4/5] w-full object-cover object-center"
            />
            <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(22,26,21,0.45) 0%, rgba(22,26,21,0) 30%, rgba(22,26,21,0) 70%, rgba(22,26,21,0.55) 100%)" }} />
          </div>
        </Reveal>
      </div>

      <div className="mt-16 grid gap-10 lg:grid-cols-12">
        <div className="hidden lg:col-span-1 lg:block">
          <TrajectorySpine />
        </div>
        <div className="lg:col-span-11">
          {MODEL_STEPS.map((st, i) => (
            <Reveal key={st.n} delay={i * 0.12} className={`group -mx-3 grid items-baseline gap-6 rounded-md px-3 py-10 transition-colors duration-300 hover:bg-white/[0.03] md:grid-cols-12 md:gap-10 ${i !== 0 ? "border-t border-white/12" : ""}`}>
              <div className="md:col-span-3">
                <span className="font-display block text-6xl leading-none text-white/25 transition-colors duration-300 group-hover:text-[#5f8f10] md:text-7xl">{st.n}</span>
              </div>
              <div className="md:col-span-9">
                <h3 className="font-display text-2xl uppercase leading-[1.02] tracking-tight text-white transition-colors duration-300 group-hover:text-[#5f8f10] md:text-3xl">{st.title}</h3>
                <p className="font-body mt-4 max-w-2xl text-lg font-normal leading-relaxed text-white/70">{st.caption}</p>
              </div>
            </Reveal>
          ))}
          <p className="font-body mt-10 border-t border-white/12 pt-8 text-lg font-medium italic text-white/60">
            The problem determines the expertise, not the other way around.
          </p>
        </div>
      </div>
    </div>
  </section>
  );
};

